import React from "react";
import Layout from "../../../../Components/Common/Layout";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import MainSection from "./MainSection";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";

const FixedAssets = () => {
  useNavHeading("Finance", `Assets`);

  return (
    <Layout title={"Financial Statements | Office Flow"}>
      <DashLayout>
        <ProtectedSection requiredPermission={PERMISSIONS.VIEW_FIXED_ASSETS} title={"Fixed Assets"}>
          <MainSection />
        </ProtectedSection>

      </DashLayout>
    </Layout>
  );
};

export default FixedAssets

